/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/476-IE': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M11.472 9.825h3.688c.028-.256.04-.517.04-.784a6.835 6.835 0 00-.924-3.442c.607-1.614.586-2.984-.227-3.803-.773-.77-2.848-.645-5.194.394a6.876 6.876 0 00-7.193 5.181c1.01-1.293 2.072-2.231 3.492-2.913-.129.121-.882.87-1.009.996-3.743 3.742-4.923 8.63-3.653 9.9.965.965 2.715.802 4.725-.182a6.836 6.836 0 003.113.744 6.869 6.869 0 006.501-4.648h-3.717a3.026 3.026 0 01-5.32 0 3.042 3.042 0 01-.358-1.432v-.011h6.035zm-6.03-1.812c.085-1.517 1.347-2.728 2.887-2.728s2.802 1.21 2.887 2.728H5.442zm8.573-5.454c.524.529.511 1.503.063 2.719a6.895 6.895 0 00-3.2-2.619c1.408-.604 2.553-.684 3.137-.1zM1.461 15.113c-.668-.669-.467-2.072.394-3.763a6.902 6.902 0 002.927 3.581c-1.491.677-2.712.792-3.321.182z"/>'
  }
})
